import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const antIcon = <LoadingOutlined style={{ fontSize: 44 }} spin className='loaderNew' data-testid='loaderNew' />;

const Loader: React.FC = () => <div> <Spin indicator={antIcon} data-testid='loader-component' /></div>;

export default Loader;
